import { CSSProperties } from 'react';
import classNames from 'classnames';

import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';
import { Meta } from '@rikstv/shared-components';

import styles from './Pill.module.css';

interface Props {
  className?: string;
  style?: CSSProperties;
}

export const Pill: FCC<Props> = ({ children, className, style }) => (
  <Meta className={classNames(styles.pill, className)} style={style}>
    {children}
  </Meta>
);

export const AccentPill: FCC<Props> = ({ className, ...props }) => (
  <Pill {...props} className={classNames(styles.accent, className)} />
);
